import axios from "axios";
import { baseURL } from "./config.js";
import qs from "qs";

export default {
  // 邮件发送验证码
  sendEmailCode(params) {
    const url = baseURL + "/tbUser/sendEmailCode";
    return axios.post(url, qs.stringify(params));
  },
  // 重置密码
  userPasswordEmail(params) {
    const url = baseURL + "/tbUser/userPasswordEmail";
    return axios.post(url, qs.stringify(params));
  },

//   验证密码
  verifyEmailCode(params) {
    const url = baseURL + "/tbUser/verifyEmailCode";
    return axios.post(url, qs.stringify(params));
  },
  // 邮件注册用户
  registerUserByEmail(params) {
    const url = baseURL + "/tbUser/addUserByEmail";
    return axios.post(url, qs.stringify(params));
  },
   // 邮件重复验证
   verifyEmail(params) {
    const url = baseURL + "/tbUser/verifyEmail";
    return axios.post(url, qs.stringify(params));
  },
};



// WEBPACK FOOTER //
// ./src/api/resetPwEn.js